import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/edit.svg'


const _withScopeId = n => (_pushScopeId("data-v-51cf300c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs_18 fw_700" }, "Summary", -1))
const _hoisted_3 = { class: "table table-striped" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Footwear type"),
    /*#__PURE__*/_createElementVNode("th", null, "Gender"),
    /*#__PURE__*/_createElementVNode("th", null, "Size"),
    /*#__PURE__*/_createElementVNode("th", null, "Process Type"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Weight")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs_18 fw_700 mt-5" }, "Composition", -1))
const _hoisted_6 = { class: "table table-striped" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Percentage"),
    /*#__PURE__*/_createElementVNode("th", null, "Weight")
  ])
], -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-end mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("table", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, _toDisplayString(_ctx.footwearData.footwearType), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.footwearData.gender), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.footwearData.propertyValue["Size"]), 1),
              _createElementVNode("td", null, _toDisplayString(_ctx.footwearData.processType), 1),
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(_ctx.footwearComposition.totalWeight) + "gr ", 1),
                (!_ctx.isReadOnly)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_0,
                      class: "pointer editIcon ms-1",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditWeightModal()))
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _hoisted_5,
        _createElementVNode("table", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedData, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.name,
                class: _normalizeClass({'group-header': !item.parentName})
              }, [
                _createElementVNode("td", null, _toDisplayString(item.indentName), 1),
                _createElementVNode("td", null, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.currency(item.percentage, 2)) + "% ", 1),
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _imports_0,
                        class: "pointer editIcon ms-1",
                        onClick: ($event: any) => (_ctx.openEditCompositionPercentageModal(item.indentName, item.percentage))
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", null, _toDisplayString(item.weight.toFixed(2)) + "gr", 1)
              ], 2))
            }), 128))
          ])
        ]),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.hasCustomComposition)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-secondary me-2",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmReset(false)))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Reset to my composition",
                      text: "Reset to my composition"
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                class: "btn btn-secondary me-2",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmReset(true)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Back to Edmond Suggestion",
                  text: "Back to Edmond Suggestion"
                })
              ]),
              _createElementVNode("button", {
                class: "btn btn-tertiary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/footwear-calculator/components-materials/' + _ctx.estimationIdentifier)))
              }, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Continue",
                  text: "Continue"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}